import { Component, Input } from '@angular/core';
import { SearchContextsEnum } from '../../enums/search-contexts.enum';
import { SearchContextModel } from '../../models/search-context.model';
import { getProvider } from '../../../../Common/Forms/models/control-value-accessor.model';

@Component({
    selector: 'agpr-monitoring-search-contexts',
    templateUrl: './monitoring-search-contexts.component.html',
    styleUrls: ['./monitoring-search-contexts.component.scss'],
    providers: [getProvider(MonitoringSearchContextsComponent)],
    standalone: false
})
export class MonitoringSearchContextsComponent {
    @Input() id: string = null;

    searchContextType: SearchContextsEnum = SearchContextsEnum.text;
    searchContexts = SearchContextsEnum;

    private noSearchContexts = {
        [SearchContextsEnum.header]: false,
        [SearchContextsEnum.lead]: false,
        [SearchContextsEnum.body]: false,
        [SearchContextsEnum.images]: false,
    };

    public selectedSearchContexts: {[key in SearchContextsEnum]?: boolean} = JSON.parse(JSON.stringify(this.noSearchContexts));

    text: SearchContextModel = new SearchContextModel(SearchContextsEnum.text);
    header: SearchContextModel = new SearchContextModel(SearchContextsEnum.header);
    lead: SearchContextModel = new SearchContextModel(SearchContextsEnum.lead);
    body: SearchContextModel = new SearchContextModel(SearchContextsEnum.body);
    images: SearchContextModel = new SearchContextModel(SearchContextsEnum.images);

    constructor() {}

    onModelChange: Function = () => {};
    onModelTouched: Function = () => {};

    /**
     * Called when changing an area to focus upon for text searching
     *
     * @param event
     * @param searchContext
     */
    updateSearchContext(event: Event, searchContext: SearchContextModel) {
        if (searchContext === this.images) {
            this.searchContextType = SearchContextsEnum.images;
            this.selectedSearchContexts = {
                [SearchContextsEnum.images]: true
            };
        } else if (searchContext === this.text) {
            this.searchContextType = SearchContextsEnum.text;
            this.selectedSearchContexts = {
                [SearchContextsEnum.header]: true,
                [SearchContextsEnum.lead]: true,
                [SearchContextsEnum.body]: true,
            };
        } else {
            this.selectedSearchContexts[searchContext.value] = !this.selectedSearchContexts[searchContext.value];
        }
        const modelChangeArray = [];
        for (const key in this.selectedSearchContexts) {
            if (!this.selectedSearchContexts[key]) {
                continue;
            }
            switch (key) {
                case SearchContextsEnum.lead:
                    modelChangeArray.push(this.lead);
                    break;
                case SearchContextsEnum.header:
                    modelChangeArray.push(this.header);
                    break;
                case SearchContextsEnum.body:
                    modelChangeArray.push(this.body);
                    break;
                case SearchContextsEnum.images:
                    modelChangeArray.push(this.images);
                    break;
            }
        }
        this.onModelChange(modelChangeArray);
    }

    /**
     * Accept value from Parent component and update local equivalents to this information
     *
     * @param searchContextAreas
     */
    writeValue(searchContextAreas: SearchContextModel[]): void {
        if (!searchContextAreas) {
            return;
        }
        this.selectedSearchContexts = JSON.parse(JSON.stringify(this.noSearchContexts));
        for (const searchContextArea of searchContextAreas) {
            this.selectedSearchContexts[searchContextArea.value] = true;
        }
        if (this.selectedSearchContexts.images === true) {
            this.searchContextType = SearchContextsEnum.images;
        } else {
            this.searchContextType = SearchContextsEnum.text;
        }
    }

    /**
     * Required as part of ControlValueAccessor
     */
    registerOnChange(fn: Function): void {
        this.onModelChange = fn;
    }

    /**
     * Required as part of ControlValueAccessor
     */
    registerOnTouched(fn: Function): void {
        this.onModelTouched = fn;
    }
}
